import io from "socket.io-client";
import { state, socketId } from "../store";

const socket = io();
let oldState = null;
state.subscribe((value) => {
	oldState = value;
});

let myId = "";

socketId.subscribe(value => {
	myId = value;
});

socket.on("id", (id) => {
	if (!myId) {
		myId = id;
		socketId.set(id);
	}
	socket.emit("join", myId);
});

socket.on("state", (newState) => {
	console.log(newState);
	const player = newState.players.find((player) => {
		return player.id === myId;
	});
	if (!player) {
		const isAdmin = newState.admins.find((player) => {
			return player.id === myId;
		}) !== undefined;

		if (!isAdmin) {
			socket.emit("join", myId);
		}
		else {
			newState.isAdmin = true;
			state.set(newState);
		}
	}
	else {
		player.isYou = true;

		state.set(newState);
	}
});

export const action = (actionName, ...data) => {
	socket.emit(actionName, ...data);
};
